import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useMutation } from "@tanstack/react-query";
import z from "zod";

export interface GenerateStripeOnboardingLinkRequest {
  refreshUrl: string;
  returnUrl: string;
}

export function useGenerateStripeOnboardingLink() {
  const worker = useDefinedWorker();

  return useMutation({
    mutationFn: async (data: GenerateStripeOnboardingLinkRequest) => {
      return await post({
        url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${worker.userId}/generate-account-link`,
        data,
        responseSchema: z.string(),
      });
    },
  });
}
